<template>
    <div class="pt15">
        <div class="sub_title">
            운송 정보
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tbody>
                <tr>
                    <td class="c_t_title">배송일</td>
                    <td>
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.invoiceDate) }}
                        </div>
                    </td>
                    <td class="c_t_title">배송번호</td>
                    <td>
                        <div class="d_block">
                            {{ orderData.shippingNumber }}
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="c_t_title">배송사</td>
                    <td>
                        <div class="d_block">
                            <el-select class="w_100" v-model="deliveryCompany" @change="parentChange('deliveryCompany', deliveryCompany)">
                                <el-option :label="data.ed_name" :value="data.ed_idx"
                                           v-for="data in parcelList" :key="`parce${data.ed_idx}`"></el-option>
                            </el-select>
                            <div class="input_error">{{ validation.firstError('deliveryCompany') }}</div>
                        </div>
                    </td>

                    <td class="c_t_title">송장번호</td>
                    <td>
                        <div class="d_block search">
                            <el-input class="table_s_input mr10" v-model="invoiceNumber" @change="parentChange('invoiceNumber', invoiceNumber)"></el-input>
                            <div class="input_error">{{ validation.firstError('invoiceNumber') }}</div>
                        </div>
                    </td>
                </tr>

                <tr v-if="checkShippingDone()">
                    <td class="c_t_title">배송완료일</td>
                    <td colspan="3">
                        <div class="d_block">
                             {{ returnDateTimeFormat(orderData.shippingDoneDate) }}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import {mapState} from "vuex";
import dateMixins from "@/mixins/dateMixins";
import util from "@/mixins/util";
import SimpleVueValidation from "simple-vue-validator";
import Vue from "vue";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    name: "ServiceShippingInformationLayout",
    mixins: [dateMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        orderClass: {default: null,},
        orderData:{
            default: () => {
            }, type: Object
        },
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
    },
    data() {
        return {
            deliveryCompany:'',
            invoiceNumber : '',
            validatorArr:['deliveryCompany','invoiceNumber'],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initData()
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('ServiceShippingInformationLayout')
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            parcelList: state => state.parcelCompany.parcelList,
        })
    },
    methods: {
        initData(){
          this.invoiceNumber = this.orderData.invoiceNumber
          this.deliveryCompany = this.orderData.deliveryCompany
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        checkShippingDone(){
            // 배송 완료일
            return !util.isEmpty(this.orderData.shippingDoneDate)
        },
        checkValidator() {
            this.$validate(['deliveryCompany','invoiceNumber'])
        },
    },
    watch: {},
    validators: {
        invoiceNumber : function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(!util.isEmpty(this.deliveryCompany) && util.isEmpty(value)) {
                        return '운송 정보를 다 입력해주세요.'
                    }
                })
        },
        deliveryCompany  : function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(!util.isEmpty(this.invoiceNumber) && util.isEmpty(value)) {
                        return '운송 정보를 다 입력해주세요.'
                    }
                })
        },
    }
}
</script>

<style scoped>

</style>
